import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { tap } from 'rxjs';

import { GeneralConstants } from 'app/constants/general-constants';
import { Cobrander } from 'app/model/cobrander';
import { ConfirmDialogData } from 'app/model/confirm-dialog-data';
import { cobranderService } from 'app/services/cobrander.service';
import { ObservableThunk, RootState } from 'app/store';

interface CoreState {
    appUpdated: boolean;
    delayUpdateMoment?: number;
    dialogData?: ConfirmDialogData;
    cobranders?: Cobrander[];
}

const initialState: CoreState = {
    appUpdated: false,
    delayUpdateMoment: undefined,
};

const coreSlice = createSlice({
    name: 'core',
    initialState,
    reducers: {
        cobrandersLoaded: (state, payload: PayloadAction<Cobrander[]>) => {
            state.cobranders = payload.payload;
        },
        reportAppUpdated: (state) => {
            if (!state.delayUpdateMoment || state.delayUpdateMoment < Date.now()) {
                state.appUpdated = true;
            }
        },
        showConfirmation: (state, payload: PayloadAction<ConfirmDialogData>) => {
            state.dialogData = payload.payload;
        },
        hideConfirmation: (state) => {
            state.dialogData = undefined;
        },
        setDelayUpdateMoment: (state, payload: PayloadAction<number>) => {
            state.delayUpdateMoment = payload.payload;
            state.appUpdated = false;
        },
    },
});

// main reducer.
export const CoreSliceReducer = coreSlice.reducer;

// selectors
export const selectAppUpdated = (state: RootState): boolean => state.core.appUpdated;
export const selectDialogData = (state: RootState): ConfirmDialogData | undefined => state.core.dialogData;

export const selectCobranders = (state: RootState): Cobrander[] | undefined => state.core.cobranders;
// actions
export const { reportAppUpdated, showConfirmation, hideConfirmation, cobrandersLoaded, setDelayUpdateMoment } =
    coreSlice.actions;

// async actions
export const loadCobranders = (): ObservableThunk<Cobrander[]> => (dispatch) =>
    cobranderService
        .listAll({ pageSize: GeneralConstants.PAGE_SIZE_HUGE })
        .pipe(tap((cobranders) => dispatch(cobrandersLoaded(cobranders))));
